import { c as _c } from "react/compiler-runtime";
import { Button, Circle, Heading, Icon, Stack, Text } from '@chakra-ui/react';
import { LuCheck } from 'react-icons/lu';
export type ConversionCompletionProps = {
  /** "Continue to {destinationLabel}"; omit for a plain "Continue". */
  destinationLabel?: string;
  onReturn: () => void;
  detail?: string;
  /** `plain` drops the panel chrome when the caller (a dialog) is already the surface. */
  variant?: 'card' | 'plain';
};

/** Return handoff after the caller confirms access; this component never grants entitlement. */
export const ConversionCompletion = t0 => {
  const $ = _c(13);
  const {
    destinationLabel,
    detail: t1,
    onReturn,
    variant: t2
  } = t0;
  const detail = t1 === undefined ? "Your access is ready." : t1;
  const variant = t2 === undefined ? "card" : t2;
  let t3;
  if ($[0] !== variant) {
    t3 = variant === "card" ? {
      bg: "colorPalette.panel",
      borderColor: "border",
      borderRadius: "lg",
      borderWidth: "1px",
      maxW: "28rem",
      p: {
        base: 5,
        md: 6
      }
    } : {};
    $[0] = variant;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Circle bg="green.muted" color="green.fg" size={10}><Icon aria-hidden={true} boxSize={5}><LuCheck /></Icon></Circle>;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Heading size={{
      base: "lg",
      md: "xl"
    }}>You’re all set</Heading>;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== detail) {
    t6 = <Stack gap={2}>{t5}<Text color="fg.muted" textStyle="sm">{detail}</Text></Stack>;
    $[4] = detail;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  const t7 = destinationLabel ? `Continue to ${destinationLabel}` : "Continue";
  let t8;
  if ($[6] !== onReturn || $[7] !== t7) {
    t8 = <Button variant="cta" onClick={onReturn}>{t7}</Button>;
    $[6] = onReturn;
    $[7] = t7;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== t3 || $[10] !== t6 || $[11] !== t8) {
    t9 = <Stack aria-live="polite" gap={5} role="status" w="full" {...t3}>{t4}{t6}{t8}</Stack>;
    $[9] = t3;
    $[10] = t6;
    $[11] = t8;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  return t9;
};